(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5339],{

/***/ 72698:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[uid]",
      function () {
        return __webpack_require__(30883);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _imports_universal_page__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11301);
/* harmony import */ var _components_Abstracts_SliceManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70820);
/* harmony import */ var _components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68971);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86238);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);





function Universal(param) {
    var slices = param.slices;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().UniversalPage),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Abstracts_SliceManager__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                mapSliceTypeToComponent: _imports_universal_page__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,
                slicesData: slices
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PageViewAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .PageViewAnalytics */ .W, {
                template: "page"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Universal);


/***/ }),

/***/ 86238:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"UniversalPage":"styles_UniversalPage__V4reY"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,3310,4213,2873,3816,5750,6169,1281,4515,5231,423,9774,2888,179], function() { return __webpack_exec__(72698); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);